// extracted by mini-css-extract-plugin
export default {"authModal":"MainContainer_authModal__xRfYC","modalTitle":"MainContainer_modalTitle__DT5Za"};